import { render } from "./ClientGuiaRemision.vue?vue&type=template&id=3ae7f59d&scoped=true"
import script from "./ClientGuiaRemision.vue?vue&type=script&lang=js"
export * from "./ClientGuiaRemision.vue?vue&type=script&lang=js"

import "./ClientGuiaRemision.vue?vue&type=style&index=0&id=3ae7f59d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae7f59d"]])

export default __exports__